import { Button, Dropdown, Form } from "react-bootstrap";
import { SearchIcon } from "Assets/icons";
import { useCallback, useState } from "react";
import { debounce } from "lodash";

const TableHeader = ({ filter, handleFilterChange, heading, filterComponent, children, resetFilter, searchPlaceholder, hideStatusFilter, hideSearch, statusOptions }) => {

  const [search, setSearch] = useState(filter?.search || "");

  const handleChangeStatus = (e) => {
    handleFilterChange("status")(e.target.value);
  }

  const handleSearchChange = useCallback(debounce((value) => {
    if (handleFilterChange) {
      handleFilterChange("search")(value);
    }
  }, 500), [handleFilterChange, 500]);

  const handleReset = (e) => {

    if (typeof resetFilter === "function") {
      resetFilter();
      setSearch("");
    };
  };

  return (
    <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
      <div className="left">
        <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
          <li className="">
            <h6 className="m-0 fw-bold themeBlue">{heading}</h6>
          </li>
          <li className="">
            <ul className="list-unstyled ps-0 mb-0 d-flex align-itmes-center filter">
              <li className="">
                <Button
                  className="border-0 d-flex align-items-center  justify-content-center"
                  variant="transparent"
                >
                  <span className="icn me-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="19"
                      viewBox="0 0 17 19"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.15 7.6C12.0988 7.6 15.3 6.12254 15.3 4.3C15.3 2.47746 12.0988 1 8.15 1C4.20116 1 1 2.47746 1 4.3C1 6.12254 4.20116 7.6 8.15 7.6Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M1 4.2998C1.00186 7.61116 3.27784 10.4877 6.5 11.2511V15.8498C6.5 16.7611 7.23873 17.4998 8.15 17.4998C9.06127 17.4998 9.8 16.7611 9.8 15.8498V11.2511C13.0222 10.4877 15.2981 7.61116 15.3 4.2998"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  Filter By
                </Button>
              </li>
              {filterComponent}
              {!hideStatusFilter ? <li className="">
                <div className="position-relative iconWithText">
                  <span
                    className="icn position-absolute"
                    style={{ left: 5 }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <g opacity="0.5">
                        <path
                          d="M10.33 16.5928H4.0293"
                          stroke="#071E3E"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M13.1406 6.90042H19.4413"
                          stroke="#071E3E"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.72629 6.84625C8.72629 5.5506 7.66813 4.5 6.36314 4.5C5.05816 4.5 4 5.5506 4 6.84625C4 8.14191 5.05816 9.19251 6.36314 9.19251C7.66813 9.19251 8.72629 8.14191 8.72629 6.84625Z"
                          stroke="#071E3E"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M20.0002 16.5538C20.0002 15.2581 18.9429 14.2075 17.6379 14.2075C16.3321 14.2075 15.2739 15.2581 15.2739 16.5538C15.2739 17.8494 16.3321 18.9 17.6379 18.9C18.9429 18.9 20.0002 17.8494 20.0002 16.5538Z"
                          stroke="#071E3E"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                    </svg>
                  </span>
                  <Form.Select
                    className="ps-5"
                    style={{ borderRadius: 0, }}
                    aria-label="Filter data by status"
                    value={filter?.status}
                    onChange={handleChangeStatus}
                  >
                    <option value="" disabled selected>Status</option>
                    {
                      statusOptions?.length > 0 ? statusOptions?.map((item) => <option value={item?.value}>{item?.label}</option>)
                        :
                        <>
                          <option value="">All</option>
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                          <option value="archived">Archived</option>
                        </>
                    }
                  </Form.Select>
                </div>
              </li> : null}
              <li>
                {!hideSearch && <div className="iconWithText position-relative h-100">
                  <Form.Control
                    type="search"
                    placeholder={searchPlaceholder || "Search"}
                    className="search-input"
                    aria-label="Search"
                    value={search}
                    onChange={(e) => {

                      setSearch(e.target.value);
                      handleSearchChange(e.target.value);
                    }}
                    style={{ height: "100%", border: 0, fontSize: "14px" }}
                  />
                  <Button
                    variant="transparent"
                    className="border-0 icn p-0 position-absolute"
                    style={{ left: 10 }}
                  >
                    <SearchIcon />
                  </Button>
                </div>}
              </li>
              <li className="">
                <Button
                  className="border-0 d-flex align-items-center  justify-content-center text-danger"
                  variant="transparent"
                  onClick={handleReset}
                >
                  <span className="icn me-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="16"
                      viewBox="0 0 12 16"
                      fill="none"
                    >
                      <path
                        d="M6 3.75V0.75L2.25 4.5L6 8.25V5.25C8.4825 5.25 10.5 7.2675 10.5 9.75C10.5 12.2325 8.4825 14.25 6 14.25C3.5175 14.25 1.5 12.2325 1.5 9.75H0C0 13.065 2.685 15.75 6 15.75C9.315 15.75 12 13.065 12 9.75C12 6.435 9.315 3.75 6 3.75Z"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                  Reset Filter
                </Button>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div className="right">
        {children}
      </div>
    </div>
  )
}

export default TableHeader;